import { Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { MediaRequestModel } from '../../../helpers/objects/request/media/media-request-model';
import { MediaResponseModel } from '../../../helpers/objects/response/media/media-response-model';

@Injectable({
  providedIn: 'root'
})
export class BackofficeSocialNetworkService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(private http: HttpClient, @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel) {
    this.appConfig = appConfigTemp;
  }

  getAll(filter: MediaRequestModel): Observable<MediaResponseModel> {
    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });
    return this.http
      .get<any>(this.appConfig.api + 'backoffice/medias/' + this.appConfig.apiPartnershipId, {
        params: httpParams
      })
      .pipe(map((response) => response.body as MediaResponseModel));
  }

  addMedia(mediaFile: any): Observable<any> {
    return this.http.post(this.appConfig.api + 'backoffice/medias/' + this.appConfig.apiPartnershipId, mediaFile);
  }

  editMedia(MediaFile: any): Observable<any> {
    return this.http.put(this.appConfig.api + 'backoffice/medias/' + this.appConfig.apiPartnershipId, MediaFile).pipe(map((response) => {}));
  }

  getBackofficeCampaignDetail(mediaId: any): Observable<any> {
    return this.http.get<any>(this.appConfig.api + 'backoffice/medias/' + this.appConfig.apiPartnershipId + '/' + encodeURIComponent(mediaId)).pipe(
      map((response) => {
        return response.body;
      })
    );
  }

  public getMediasContent(documentId: string, download: boolean): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (token === null) {
      throw new Error('No token found in session storage.');
    }
    const archiveType = download ? 'digitalArchiveContentId' : 'digitalArchivePresentationImageId';
    const params = new HttpParams({
      fromObject: {
        [archiveType]: documentId,
        Authorization: token
      }
    });
    return this.http.get<any>(this.appConfig.api + 'setup/medias/' + this.appConfig.apiPartnershipId + '/content', { params });
  }
}
